import { Shield, CheckCircle, RefreshCw, Headphones } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const guarantees = [
  {
    icon: Shield,
    title: "Garansi 100% Aman",
    description: "Setiap akun yang dijual sudah diverifikasi dan dijamin keamanannya.",
    color: "from-primary to-primary/80"
  },
  {
    icon: RefreshCw,
    title: "Garansi Penggantian",
    description: "Jika ada masalah dengan akun, kami siap mengganti dengan akun baru.",
    color: "from-success to-success/80"
  },
  {
    icon: CheckCircle,
    title: "Garansi Sesuai Durasi",
    description: "Akun dijamin aktif sesuai durasi yang tertera pada produk.",
    color: "from-info to-info/80"
  },
  {
    icon: Headphones,
    title: "Support 24/7",
    description: "Tim support kami siap membantu kapanpun Anda membutuhkan.",
    color: "from-warning to-warning/80"
  }
];

export function GaransiSection() {
  return (
    <section id="garansi" className="py-16 lg:py-24 bg-card">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Garansi <span className="text-gradient">Kami</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Kami berkomitmen memberikan layanan terbaik dengan garansi yang jelas dan transparan.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {guarantees.map((item, index) => (
            <Card
              key={index}
              className="group border border-border hover:shadow-card transition-all duration-300 animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <CardContent className="p-6 text-center">
                <div
                  className={`mx-auto w-14 h-14 rounded-xl bg-gradient-to-br ${item.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}
                >
                  <item.icon className="h-7 w-7 text-primary-foreground" />
                </div>
                <h3 className="font-semibold text-lg mb-2">{item.title}</h3>
                <p className="text-sm text-muted-foreground">{item.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
